/**
 *  Vue 3 initialization
 */
import { createApp, defineAsyncComponent } from 'vue';
import store from '@js/vue/store/store.js';
import { translations } from '@js/vue/translations.js';

/**

 * Create a fresh Vue application instance.
 */
window.Vue = createApp({});
window.Vue.config.productionTip = true;
window.Vue.config.devtools = true;

window.Vue.provide('lang', document.documentElement.lang.substring(0, 2));
window.Vue.provide('currency', document.body.dataset.currency);
window.Vue.provide('currencyCode', document.body.dataset.currencyCode);
window.Vue.provide('translations', translations);

//Vuex
window.Vue.use(store);

// TODO enable devtools in dev/local
// window.Vue.config.devtools = true;
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
/*
const files = require.context('./', true, /\.vue$/i);
files
    .keys()
    .map((key) =>
        Vue.component(key.split('/').pop().split('.')[0], files(key).default)
    );
*/
const ServiceCard = defineAsyncComponent(() => import('./vue/components/ServiceCard.vue'));
const CtaCard = defineAsyncComponent(() => import('./vue/components/CtaCard.vue'));
const CardsWithMapAndFilters = defineAsyncComponent(() => import('./vue/components/CardsWithMapAndFilters.vue'));
const Booking = defineAsyncComponent(() => import('./vue/components/booking/Booking.vue'));
const DatePicker = defineAsyncComponent(() => import('./vue/components/DatePicker.vue'));
const GoogleReviews = defineAsyncComponent(() => import('./vue/components/GoogleReviews.vue'));

window.Vue.component('service-card', ServiceCard);
window.Vue.component('cta-card', CtaCard);
window.Vue.component('cards-with-map-and-filters', CardsWithMapAndFilters);
window.Vue.component('booking', Booking);
window.Vue.component('date-picker', DatePicker);
window.Vue.component('google-reviews', GoogleReviews);

/**
 * Attach Vue application instance to the page. (id = app)
 */
window.Vue.mount('#app');
